import React from 'react';
import { Box, Center, HStack, Modal, SmallCloseIcon, Text, VStack } from 'native-base';
import { i18nFn } from '@springbig/shared';
import { useGeneralStyles, useTopNavigationStyles } from '../../shared/styles';
import Pressable from '~/shared/Pressable';

export default function ConfirmationModal({ isOpen, onClose, t, giftCardValue }: { isOpen: boolean, onClose: () => void, t: i18nFn, giftCardValue: number }) {
    const gStyle = useGeneralStyles();
    const {
        icon
    } = useTopNavigationStyles();

    return (
        <Center flex={1}>
          <Modal isOpen={isOpen} onClose={() => onClose}>
            <Modal.Content>
                <HStack  w="100%" justifyContent="space-between" alignItems="center">
                  <Box
                    borderRadius="full"
                    size={10}
                    alignItems="center"
                    justifyContent="center"
                    mt={2}
                  >
                    <Text fontSize="xl" color={gStyle.button_background} fontWeight="bold">
                      $
                    </Text>
                  </Box>
                  <Pressable alignSelf={'flex-end'} p={2} onPress={onClose}>
                    <SmallCloseIcon size='md' color={gStyle.button_background} />
                  </Pressable>
                </HStack>
                <VStack alignItems="center" mb={4}>
                    <Text fontSize="lg" fontWeight="bold">
                        {t('giftCard.confirmation_modal.complete')}
                    </Text>
                    <Text fontSize="2xl">
                        ${giftCardValue}
                    </Text>
                </VStack>
            </Modal.Content>
          </Modal>
        </Center>
    );
}
